
export default({
  status: [{value:'aktiv',label:'Aktiv'},{value:'inaktiv',label:'Inaktiv'},{value:'onhold',label:'On-Hold'}],
  wochentage: ['Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Sonntag'],
  roles :[
    // {value:"",label:"Bitte wählen"},
    {value:"admin",label:"Admin"},
    {value:"gl",label:"Regionalleiter"},
    {value:"doit",label:"DO IT! Mitarbeiter"},
  ],
  berichtabgegebenTypen:[
    {value:true,label:"Bericht final abgegeben"},
    {value:false,label:"Bericht nicht final abgegeben"},
  ],
  tagsberichtfiles:[
    {value:"einsatz_sales",label:"Sales"},
    {value:"einsatz_default",label:"Alle anderen"},
  ],
  frageTypen:[
    {value:"header",label:"Überschrift"},
    {value:"number",label:"Nummern-Abfrage"},
    {value:"text",label:"Text-Frage"},
    {value:"select",label:"Dropdown mit Antwortmöglichkeiten"},
    {value:"radio",label:"Radio-Buttons"},
  ],
  geschlechter:[
    {value:"male",label:"Männlich"},
    {value:"female",label:"Weiblich"},
    {value:"divers",label:"Divers"},
  ],
  variantenOptions:[
    {value:1,label:"Fix"},
    {value:2,label:"CPO"},
  ],
  ticketThemen :[
    "Abrechnung",
    "Einsätze",
    "Abgleich",
    "Sonstiges",
  ],
  ticketStatus :[
    "Neu",
    "In Arbeit",
    "Erledigt"
  ],
  kundenroles :[
    // {valvalue:"",label:"Bitte wählen"},
    {value:"",label:"Keine Rolle"},
    {value:"aussendienstler",label:"Außendienstler"},
    {value:"genemiger",label:"Genemiger"},
    {value:"entscheider",label:"Entscheider"},
    {value:"pruefer",label:"Prüfer"},
    {value:"anwender",label:"Anwender"},
    {value:"coach",label:"Coach"},
  ],
  warenarten :[
    // {valvalue:"",label:"Bitte wählen"},
    {value:"",label:"Keine Art"},
    {value:"Ware",label:"Ware"},
    {value:"Outfit",label:"Outfit"},
    {value:"Zubehör",label:"Zubehör"},
  ],

  warenmarken :[
    // {valvalue:"",label:"Bitte wählen"},
    {value:"",label:"Keine Marke"},
    {value:"Dunhill",label:"Dunhill"},
    {value:"Pall Mall",label:"Pall Mall"},
    {value:"Lucky",label:"Lucky"},
    {value:"Luckies",label:"Luckies"},
    {value:"LuckiesBlue",label:"Luckies Blue"},
    {value:"LuckiesRed",label:"Luckies Red"},
    
    {value:"LuckiesCraftedBlue",label:"Luckies Crafted Blue"},
    {value:"LuckiesCraftedRed",label:"Luckies Crafted Red"},

    {value:"Glo",label:"Glo"},
    {value:"Vuse",label:"Vuse"},
    {value:"OhneProdukt",label:"Ohne Produkt"},

  ],
  ortTypen:[
    {value:"Festival",label:"Festival"},
    {value:"Event",label:"Event"},
    {value:"Media Markt",label:"Media Markt"},
    {value:"Gastro",label:"Gastro"},
    {value:"Telekom-Shop",label:"Telekom-Shop"},
    // {value:"Telekom-Shop",label:"T-Shop"},
    {value:"EP/MediMax",label:"EP/MediMax"},
    {value:"Fachhandel",label:"Fachhandel"},
    {value:"Saturn",label:"Saturn"},
    {value:"Postbank",label:"Postbank"},
    {value:"Öffentl. Platz",label:"Öffentl. Platz"},
    {value:"Universität",label:"Universität"},
    {value:"Club",label:"Club"},
    {value:"Off-Location",label:"Off-Location"},
    {value:"LEH",label:"LEH"},
    {value:"EKZ",label:"EKZ"},
    {value:"Expert",label:"Expert"},
    {value:"Messe",label:"Messe"},
    {value:"Callcenter",label:"Callcenter"},
    {value:"Baumarkt",label:"Baumarkt"},
    {value:"real,- SB-Warenhaus GmbH",label:"real,- SB-Warenhaus GmbH"},
  ],
  promotionfiletypen :[
    { value: "", label: "Standard" },
    { value: "vertrag", label: "Vertrag" },
    { value: "sonstiges", label: "Sonstiges" },
  ],
  gebiete :[
    // {value:"",label:"Bitte wählen"},
    {value:"nord",label:"Nord"},
    {value:"sued",label:"Süd"},
    {value:"west",label:"West"},
    {value:"ost",label:"Ost"}
  ],
  regionen :[
    // {value:"",label:"Bitte wählen"},

    {value:"west",label:"West"},
    {value:"suedwest",label:"Südwest"},
    {value:"suedost",label:"Südost"},
    {value:"nordost",label:"Nordost"},
    {value:"nord",label:"Nord"},
    {value:"sued",label:"Süd"},
    {value:"mitte",label:"Mitte"},
    {value:"Augsburg",label:"Augsburg"},
    {value:"Hamburg",label:"Hamburg"},
    {value:"Berlin",label:"Berlin"},
    {value:"Ruhrgebiet",label:"Ruhrgebiet"},
    {value:"Köln",label:"Köln"},
    {value:"Düsseldorf",label:"Düsseldorf"},
    {value:"Frankfurt",label:"Frankfurt"},
    {value:"Stuttgart",label:"Stuttgart"},
    {value:"Nürnberg",label:"Nürnberg"},
    {value:"München",label:"München"},
    {value:"Erkelenz",label:"Erkelenz"},
    {value:"Erlangen",label:"Erlangen"},

  ],
   einsatzstatus  :[
    { value: "neu", label: "Neu" },
    { value: "zugesagt", label: "Zugesagt" },
    { value: "abgesagt", label: "Abgesagt" },
  ],
  einsatztypen:[
    { value: "normal", label: "Normal" },
    { value: "nachhol", label: "Nachholtermin" },
    { value: "ausfall", label: "Ausfalltermin" },
    { value: "schulung", label: "Schulung" },
  ],
  produkttypen:[
    { value: "", label: "Standard" },
    { value: "hauptprodukt", label: "Hauptprodukt" },
    { value: "nebenprodukt", label: "Nebenprodukt" },
  ],
  einsatzarten:[
    { value: "sales", label: "Einsatz / Sales" },
    { value: "zufuehrung", label: "Zuführung" },
  ],
    getRoleFor:function(kuerzel){

    for(let i=0;i< this.roles.length;i++){
        let role=this.roles[i]
        if(role.value==kuerzel){
            return role.label
        }
    }
  },
  getGebietFor:function(kuerzel){

    for(let i=0;i< this.gebiete.length;i++){
        let gebiet=this.gebiete[i]
        if(gebiet.value==kuerzel){
            return gebiet.label
        }
    }
  },
  getKundenroleFor:function(kuerzel){

    for(let i=0;i< this.kundenroles.length;i++){
        let kundenrole=this.kundenroles[i]
        if(kundenrole.value==kuerzel){
            return kundenrole.label
        }
    }
  },

  nationalitaeten:[
    'Deutsch', 'Dänisch', 'Englisch', 'Französisch', 'Italienisch', 'Jugoslawisch', 'Niederländisch', 'Polnisch', 'Portugiesisch', 'Rumänisch', 'Russisch', 'Schwedisch', 'Spanisch', 'Tschechisch', 'Türkisch', 'Ungarisch'
  ],

  haarfarben:[
   "Braun", "Blond", "Rot", "Schwarz"
  ],
  haarlaengen:["Kurz", "Mittel", "Lang"],
  konfektionsgroessen:["34", "36","38", "40", "42", "44-54", "46", "48", "50", "52", "106"],
  tshirtgroessen:["XS", "S", "M", "L", "XL", "XXL"],
  jeansgroessen:["--------------", "Herren", "--------------", "31/32",
  "32/32",
  "34/32",
  "36/32",
  "38/32",
  "40/32",
  "42/34",
  "44/36",
  "28/34",
  "29/34",
  "31/34",
  "32/34",
  "33/34",
  "34/34",
  "36/34",
  "38/34",
  "40/36",
  "42/36",
  "28/34",
  "30/34",
  "31/36",
  "32/36",
  "33/36",
  "34/36",
  "36/36",
  "38/36",
  "--------------", "Damen", "--------------"],
  schuhgroessen:[    "33",    "34",    "35",    "36",    "37",    "38",    "39",    "40",    "41",    "42",    "43",    "44",    "45",    "46",    "47",    "48",    "49",    "50"  ],
  schulabschluesse:["Hauptschulabschluss", "Mittlere Reife", "Fachhochschulreife", "Allgm. Hochschulreife", "Abgeschlossene Ausbildung", "Abgeschlossenes Studium"],
  sprachkenntnisse:["Schule", "Fließend", "Verhandlungssicher", "Muttersprache"],
  erfahrungen:[
"Aufbauerfahrung",
"Eventleitungserfahrung",
"Gesangserfahrung",
"Haustier",
"Hostess",
"Keine Erfahrungen",
"Kinderschminken",
"Kletterschein",
"Malerei",
"Moderationserfahrung",
"Schauspielerfahrung",
"Szenenkenntnisse",
"Teamleitererfahrung",
"Trendscouterfahrung",
"Vertriebserfahrung",
"Automotive",
"Diskotheken/Clubs",
"Gastronomie",
"Kosmetik",
"Kreditkarten",
"Lebensmittel/ Verkostung",
"Mode/Textil",
"Navigation",
"Sport/Wellness",
"Telekommunikation",
"Unterhaltungselektronik",

  ],
  arbeitsfelder:[

    "Automotive",
    "Diskotheken/Clubs",
    "Gastronomie",
    "Kosmetik",
    "Kreditkarten",
    "Lebensmittel/ Verkostung",
    "Mode/Textil",
    "Navigation",
    "Sport/Wellness",
    "Telekommunikation",
    "Unterhaltungselektronik",
  ],
  wochentage:[
    "Montag	",
    "Dienstag	",
    "Mittwoch	",
    "Donnerstag	",
    "Freitag	",
    "Samstag	",
    "Sonntag",
  ],
  zeiten:[
   "Vormittags",
   "Nachmittags",
   "Abends",
   "Ganztags",
  ],
  fuehrerscheine:{
    pkw: ["Keiner", "B", "BE", "S"],
    motorrad: ["Keiner", "A", "A1", "M"],
    lkw:["Keiner", "C", "CE", "C1", "C1E"],
    bus:["Keiner", "D", "DE", "D1", "D1E"],
  },
  reisebereitschaften:["Bis 50 km","Bis 100 km","Bis 200 km","Egal"],
  laender:["Deutschland","Österreich","Schweiz","Niederlande","Polen"],
  dokumentVerwerfenGruende:[
"Nicht vollständig",
"Fehlende Unterschriften",
"Fehlerhaft",
"Nicht lesbar",
"Sonstiges",


  ],
  dokument_typen:[
    'Vertrag Single',
    'Vertrag Multi',
    'Vertrag VKF',
    'Vertrag',
    'Gewerbeschein',
    'Führungszeugnis',
    'Führerschein',
    'Gesundheitszeugnis',
    'Sales Academy',
    "Archiv"
  ],
  dokument_typen_promoter:[
    'Vertrag Single',
    'Vertrag Multi',
    'Vertrag VKF',
    'Vertrag',
    'Gewerbeschein',
    'Führungszeugnis',
    'Führerschein',
    'Gesundheitszeugnis',
    'Sonstiges',
  ],

  produktgruppen:[ 'Deutschland LAN', 'TP', 'DP','SP','Hardware','Zubuchoption','DSL','Energie','Kabel','TP Fokus'],
  // produktgruppen_vertrag:[ 'Deutschland LAN', 'TP', 'DP','SP','TP Fokus'], // Alle anderen
  produktgruppen_vertrag:[ 'DP','TP','TP Fokus'], // Alle anderen
  produktgruppen_vertrag_msd:[ 'DSL','Energie','Kabel'], // Nur MSD
  geschaeftsfaelle:[ 'N/N', 'VVLup','VVLd', 'W/N', 'VVLn', 'W/W','KOMPLETTWECHSEL_NEUKUNDE','NEUKUNDE','PRODUKTWECHSEL','BESTANDSKUNDE','Ohne' ],

  mwstsaetze  :[0,7,19],

  ispliste:["Telekom","1&1","M-Net","O2","Pyur","Vodafone DSL","Vodafone NRW","Vodafone Kabel","Energie"],
  bandbreiteliste:["S","M","L","XL","XXL","GIGA"],

  feedbackGruende:[

    {label:'Ich bestätige den Stornogrund',value:'10',target:'STORNO'},
    {label:'Bitte erneut prüfen',value:'20',target:'NACHARBEIT'},
    // {label:'Auftrag wurde erfolgreich bereitgestellt',value:'30',target:'NACHARBEIT'},
    // {label:'Auftrag in Nacharbeit, weil...',value:'40',target:''},
    // {label:'Auftrag in Produktion, weil...	',value:'50',target:''},
    // {label:'Produkt aus technischen Gründen nicht möglich',value:'70',target:'NACHARBEIT'},
    // {label:'Sonstiges',value:'80',target:''},
    // {label:'Auftrag zu Unrecht von Hotline storniert. Auftrag wurde neu aufgenommen',value:'11',target:'NACHARBEIT'},
    // {label:'Warum? Die Kaution wurde zwar nicht bezahlt, die Verantwortung liegt aber nicht beim DVM, daher provisionsrelevant.',value:'90',target:'NACHARBEIT'},
    // {label:'Warum? Die Kaution wurde bezahlt.',valueey:'100',target:'NACHARBEIT'},
    // {label:'Kopie des Vertrages liegt im Markt mit Unterschrift vor',value:'110',target:'NACHARBEIT'},
  ]

    // {value:"Media Markt dasö ldjhö askldfjhsaldk fjjashdfl aksdjhfa sldkfjashdf l",label:"11 das das dasd asdf asdf asdf sdfas dfasdfasdfasdf asdf asd1"},
    // {value:"Gastro",label:"Gastro"},
    // {value:"Telekom-Shop",label:"Telekom-Shop"},
    // // {value:"Telekom-Shop",label:"T-Shop"},
    // {value:"EP/MediMax",label:"EP/MediMax"},
    // {value:"Fachhandel",label:"Fachhandel"},
    // {value:"Saturn",label:"Saturn"},
    // {value:"Postbank",label:"Postbank"},
    // {value:"Öffentl. Platz",label:"Öffentl. Platz"},
    // {value:"Universität",label:"Universität"},
    // {value:"Club",label:"Club"},
    // {value:"Off-Location",label:"Off-Location"},
    // {value:"LEH",label:"LEH"},
    // {value:"EKZ",label:"EKZ"},
    // {value:"Expert",label:"Expert"},
    // {value:"Messe",label:"Messe"},
    // {value:"Callcenter",label:"Callcenter"},
    // {value:"Baumarkt",label:"Baumarkt"},
    // {value:"real,- SB-Warenhaus GmbH",label:"real,- SB-Warenhaus GmbH"},
  // ],
})
